"use client";
import { MapPin } from "lucide-react";
import { clickLocationGA, clickWhatsAppGA } from "../../../lib/analytics";
import { MAP_URL, STORE, STORE_COORDINATES } from "../../../lib/site";
export { MAP_URL } from "../../../lib/site";

export function StoreLocationMap() {
  return (
    <div className="visit-map">
      <iframe
        title="Shop House General Trading location in Al Ain"
        src={`https://www.google.com/maps?q=${encodeURIComponent(STORE_COORDINATES)}&z=17&output=embed`}
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        tabIndex={-1}
      />
      <a
        className="visit-map-link"
        href={MAP_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Get directions to Shop House General Trading in Google Maps (opens in a new tab)"
        onClick={() => clickLocationGA("location_map")}
      >
        <span>
          Get directions in Google Maps <MapPin size={18} aria-hidden="true" />
        </span>
      </a>
    </div>
  );
}
export function WhatsAppLink({
  label = "WhatsApp us",
  source = "store",
  message,
  className = "",
}: {
  label?: string;
  source?: string;
  message?: string;
  className?: string;
}) {
  return (
    <a
      className={`store-button whatsapp ${className}`}
      href={`https://wa.me/${STORE.whatsapp}${message ? `?text=${encodeURIComponent(message)}` : ""}`}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => clickWhatsAppGA(source)}
    >
      <svg
        width={19}
        height={19}
        viewBox="0 0 24 24"
        fill="currentColor"
        aria-hidden="true"
        focusable="false"
      >
        <path d="M20.52 3.48A11.91 11.91 0 0 0 12.04 0C5.46 0 .1 5.35.1 11.94c0 2.1.55 4.16 1.6 5.98L0 24l6.25-1.64a11.94 11.94 0 0 0 5.79 1.48h.01c6.58 0 11.94-5.35 11.95-11.94a11.87 11.87 0 0 0-3.48-8.42ZM12.05 21.82a9.9 9.9 0 0 1-5.05-1.38l-.36-.21-3.71.97.99-3.62-.24-.37a9.87 9.87 0 0 1-1.52-5.27c0-5.47 4.45-9.92 9.93-9.92a9.85 9.85 0 0 1 7.02 2.91 9.85 9.85 0 0 1 2.9 7.03c0 5.47-4.45 9.92-9.96 9.86Zm5.44-7.43c-.3-.15-1.77-.87-2.04-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.95 1.17-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.88-.79-1.48-1.77-1.65-2.07-.18-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.18.2-.3.3-.5.1-.2.05-.38-.02-.53-.08-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.8.37-.27.3-1.04 1.02-1.04 2.49s1.07 2.89 1.22 3.09c.15.2 2.1 3.2 5.08 4.49.71.3 1.27.49 1.7.63.71.22 1.36.19 1.87.11.57-.09 1.77-.72 2.02-1.42.25-.7.25-1.3.18-1.42-.08-.13-.28-.2-.57-.35Z" />
      </svg>
      {label}
    </a>
  );
}
export function DirectionsLink({
  source = "store",
  label = "Get directions",
}: {
  source?: string;
  label?: string;
}) {
  return (
    <a
      className="store-button outline"
      href={MAP_URL}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => clickLocationGA(source)}
    >
      <MapPin size={19} aria-hidden="true" />
      {label}
    </a>
  );
}
